import React from 'react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/content';
import { OFFER_SECTION_ID } from '../utils/scroll';
export function StickyCta() {
  const hasCheckout = Boolean(offer.checkoutUrl);
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-navy-900 px-4 pt-3 sm:hidden" style={{
    paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
  }} data-id="element-192" data-mp="2xno2dev4kqus">
      <CtaButton size="md" label={hasCheckout ? 'Jetzt kaufen – 19 €' : 'Zum Angebot – 19 €'} targetId={OFFER_SECTION_ID} href={offer.checkoutUrl} data-id="element-193" data-mp="3petub80ozi8z" />
    </div>;
}